<div class="pagination-skeleton loading" *ngIf="isLoading; else pagination"></div>

<ng-template #pagination>
    <div class="pagination">
        <app-button type="link" [iconReverse]="true" colorClass="color-gray-300" fontWeight="400" height="30px" [disabled]="disabledPreviousPage" (onClick)="onPreviousPage()">
            Anterior
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="feather feather-chevron-left pagination-icon pagination-simple" slot="icon" [class.disabled]="disabledPreviousPage">
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
        </app-button>
        <div class="pagination-separator">|</div>
        <app-button type="link" colorClass="color-gray-300" fontWeight="400" height="30px" [disabled]="disabledNextPage" (onClick)="onNextPage()">
            Siguiente
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="feather feather-chevron-right pagination-icon pagination-icon--simple" [class.disabled]="disabledNextPage" slot="icon">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
        </app-button>
    </div>
    <p class="current-page">
        Página {{_currentPage+1}}
    </p>
</ng-template>